<script>
import CandelaControl from '@/components/controls/CandelaControl'
export default {
  extends: CandelaControl,
  name: 'candela-toggle'
}
</script>

<template>
<div class='candela-toggle d-flex flex-column align-center align-self-stretch'>
  <v-switch class='ma-0 pa-0' v-model='value' color='primary'
    :ripple='false' dense hide-details inset/>
  <div class='font-weight-bold overline mt-2 primary--text toggle-label'>{{label}}</div>
</div>
</template>

<style lang='sass' scoped>
.toggle-label
  white-space: nowrap
</style>
